import _toConsumableArray from "/home/runner/work/awesome-gatsby-starter/awesome-gatsby-starter/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.object.from-entries.js";
// src/extend-theme.ts
import { theme, isChakraTheme } from "@chakra-ui/theme";
import mergeWith from "lodash.mergewith";
function isFunction(value) {
  return typeof value === "function";
}
function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}
function extendTheme() {
  for (var _len2 = arguments.length, extensions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    extensions[_key2] = arguments[_key2];
  }
  var overrides = [].concat(extensions);
  var baseTheme = extensions[extensions.length - 1];
  if (isChakraTheme(baseTheme) && overrides.length > 1) {
    overrides = overrides.slice(0, overrides.length - 1);
  } else {
    baseTheme = theme;
  }
  return pipe.apply(void 0, _toConsumableArray(overrides.map(function (extension) {
    return function (prevTheme) {
      return isFunction(extension) ? extension(prevTheme) : mergeThemeOverride(prevTheme, extension);
    };
  })))(baseTheme);
}
function mergeThemeOverride() {
  for (var _len3 = arguments.length, overrides = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    overrides[_key3] = arguments[_key3];
  }
  return mergeWith.apply(void 0, [{}].concat(overrides, [mergeThemeCustomizer]));
}
function mergeThemeCustomizer(source, override, key, object) {
  if ((isFunction(source) || isFunction(override)) && Object.prototype.hasOwnProperty.call(object, key)) {
    return function () {
      var sourceValue = isFunction(source) ? source.apply(void 0, arguments) : source;
      var overrideValue = isFunction(override) ? override.apply(void 0, arguments) : override;
      return mergeWith({}, sourceValue, overrideValue, mergeThemeCustomizer);
    };
  }
  return void 0;
}

// ../shared-utils/src/index.ts
function isObject(value) {
  var type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/theme-extensions/with-default-color-scheme.ts
function withDefaultColorScheme(_ref) {
  var colorScheme = _ref.colorScheme,
    components = _ref.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if (isObject(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withColorScheme = {
          defaultProps: {
            colorScheme: colorScheme
          }
        };
        return [componentName, withColorScheme];
      }))
    });
  };
}

// src/theme-extensions/with-default-size.ts
function withDefaultSize(_ref2) {
  var size = _ref2.size,
    components = _ref2.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if (isObject(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withSize = {
          defaultProps: {
            size: size
          }
        };
        return [componentName, withSize];
      }))
    });
  };
}

// src/theme-extensions/with-default-variant.ts
function withDefaultVariant(_ref3) {
  var variant = _ref3.variant,
    components = _ref3.components;
  return function (theme2) {
    var names = Object.keys(theme2.components || {});
    if (Array.isArray(components)) {
      names = components;
    } else if (isObject(components)) {
      names = Object.keys(components);
    }
    return mergeThemeOverride(theme2, {
      components: Object.fromEntries(names.map(function (componentName) {
        var withVariant = {
          defaultProps: {
            variant: variant
          }
        };
        return [componentName, withVariant];
      }))
    });
  };
}

// src/theme-extensions/with-default-props.ts
function pipe2() {
  for (var _len4 = arguments.length, fns = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    fns[_key4] = arguments[_key4];
  }
  return function (v) {
    return fns.reduce(function (a, b) {
      return b(a);
    }, v);
  };
}
function withDefaultProps(_ref4) {
  var _ref4$defaultProps = _ref4.defaultProps,
    colorScheme = _ref4$defaultProps.colorScheme,
    variant = _ref4$defaultProps.variant,
    size = _ref4$defaultProps.size,
    components = _ref4.components;
  var identity = function identity(t) {
    return t;
  };
  var fns = [colorScheme ? withDefaultColorScheme({
    colorScheme: colorScheme,
    components: components
  }) : identity, size ? withDefaultSize({
    size: size,
    components: components
  }) : identity, variant ? withDefaultVariant({
    variant: variant,
    components: components
  }) : identity];
  return function (theme2) {
    return mergeThemeOverride(pipe2.apply(void 0, fns)(theme2));
  };
}
export { extendTheme, mergeThemeOverride, withDefaultColorScheme, withDefaultProps, withDefaultSize, withDefaultVariant };